import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig} from '@angular/material/legacy-snack-bar';
import {Subject} from 'rxjs';

@Component({
    selector: 'ngc-input-field-dialog',
    templateUrl: './input-field-dialog.component.html',
    styleUrls: ['./input-field-dialog.component.scss']
})
export class InputFieldDialogComponent implements OnInit {

    formGroup: UntypedFormGroup;
    message: string;
    copyMessage: string;
    closeBtnName: string;
    saveBtnName = 'Save';
    save$: Subject<string>;
    isSaving: boolean;

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydownHandler(event: KeyboardEvent) {
        if (this.formGroup.valid && !this.isSaving) {
            this.onSave();
        }
        event.preventDefault();
    }
    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        if (!this.isSaving) {
            this.onClose();
        }
    }

    constructor(public dialogRef: MatDialogRef<InputFieldDialogComponent>,
                public snackBar: MatSnackBar,
                @Inject(MAT_DIALOG_DATA) public injectedData: {
                    inputFields: IInputField[];
                    dialogTitle: string;
                    message: string;
                    parentOU?: string;
                    closeBtnName: string;
                    saveBtnName: string;
                    copyMessage: string;
                    save$: Subject<string>;
                }) {
        this.formGroup = new UntypedFormGroup({});

        this.formGroup.addControl('parentOUField', new UntypedFormControl(this.injectedData.parentOU || '', Validators.required));
        this.formGroup.controls['parentOUField'].setValue(this.injectedData.parentOU || '');
        this.formGroup.controls['parentOUField'].disable();

        this.injectedData.inputFields.forEach((inputField: IInputField, index: number) => {
            this.formGroup.addControl(`inputField${index}`, new UntypedFormControl(
                inputField.value || '',
                [Validators.required].concat(inputField.validators)
            ));

            if (inputField?.disabled) {
                this.formGroup.controls[`inputField${index}`].disable();
            }
        });

        this.message = this.injectedData.message;
        this.closeBtnName = this.injectedData.closeBtnName;
        this.saveBtnName = this.injectedData.saveBtnName || this.saveBtnName;
        this.copyMessage = this.injectedData.copyMessage;
        this.save$ = this.injectedData.save$;
    }

    ngOnInit(): void {
    }

    onSave(value: string = this.formGroup.controls.inputField0.value) {
        if (this.save$) {
            this.isSaving = true;
            this.save$.next(value);
        } else {
            this.dialogRef.close(value);
        }

    }

    onClose() {
        if (this.save$) {
            this.save$.next('');
        }
        this.dialogRef.close();
    }

    onCopyToClipboard() {
        this.snackBar.open(this.copyMessage + ' copied to Clipboard' , '', <MatSnackBarConfig>{duration: 1500});
    }
}

export interface IInputField {
    value: string;
    label: string;
    placeholder: string;
    copy: boolean;
    disabled: boolean;
    validators: ValidatorFn[];
}
